/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Submitted_SuccessfullyInputs */

const en_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobs submitted successfully`)
};

const fr_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâches soumises avec succès`)
};

const de_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobs erfolgreich eingereicht`)
};

const it_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavori inviati con successo`)
};

const ru_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявки успешно отправлены.`)
};

const es_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajos enviados exitosamente`)
};

const zh_cn2_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已成功提交职位`)
};

const ja_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョブが正常に送信されました`)
};

const hi_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य सफलतापूर्वक सबमिट हो गए`)
};

const pt_pt2_jobs_submitted_successfully = /** @type {(inputs: Jobs_Submitted_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhos submetidos com sucesso`)
};

/**
* | output |
* | --- |
* | "Jobs submitted successfully" |
*
* @param {Jobs_Submitted_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const jobs_submitted_successfully = /** @type {((inputs?: Jobs_Submitted_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Submitted_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_jobs_submitted_successfully(inputs)
	if (locale === "de") return de_jobs_submitted_successfully(inputs)
	if (locale === "it") return it_jobs_submitted_successfully(inputs)
	if (locale === "ru") return ru_jobs_submitted_successfully(inputs)
	if (locale === "es") return es_jobs_submitted_successfully(inputs)
	if (locale === "zh-CN") return zh_cn2_jobs_submitted_successfully(inputs)
	if (locale === "ja") return ja_jobs_submitted_successfully(inputs)
	if (locale === "hi") return hi_jobs_submitted_successfully(inputs)
	if (locale === "pt-PT") return pt_pt2_jobs_submitted_successfully(inputs)
	return en_jobs_submitted_successfully(inputs)
});